






export default
  name: 'LoadingIndicator'
  props: ['show', 'size']

  computed:
    calculatedSize: -> "#{@formatedSize()}px"
    calculatedViewBox: -> "0 0 #{@formatedSize()} #{@formatedSize()}"
    calculatedAxis: -> @formatedSize() / 2
    calculatedRadius: -> (@formatedSize() / 2) - 2
  
  methods:
    formatedSize: -> s = parseInt(@size || '64')
